import { v4 as uuid } from 'uuid';

const maybeAdd = (
  result: any,
  type: string,
  seen: Array<string>,
  prepend?: boolean,
  data?: object,
) => {
  if (seen.includes(type)) {
    return;
  }

  const id = uuid();

  if (!data) {
    data = {};
  }

  result.blocks[id] = {
    '@type': type,
    ...data,
  };

  if (prepend) {
    result.blocks_layout.items = [id, ...result.blocks_layout.items];
  } else {
    result.blocks_layout.items = [...result.blocks_layout.items, id];
  }
};

export const blocksConfig = {
  DegreeProgram: (result: any, seen: Array<string>) => {
    maybeAdd(result, 'keydata', seen, true, {
      required: true,
    });
  },
  ContinuingEducation: (result: any, seen: Array<string>) => {
    maybeAdd(result, 'keydata', seen, true, {
      required: true,
    });
  },
  FHNWEvent: (result: any, seen: Array<string>) => {
    maybeAdd(result, 'keydata', seen, true, {
      required: true,
    });
  },
  InfoEvent: (result: any, seen: Array<string>) => {
    blocksConfig.FHNWEvent(result, seen);
  },
  Project: (result: any, seen: Array<string>) => {
    maybeAdd(result, 'keydata', seen, true, {
      required: true,
    });
  },
};
